<template>
    <div class="qr-scanner-component">
      <p class="error">{{ error }}</p>
      <span class="qr-scanner-close" @click="$emit('close')">
            <img src="@/assets/img/ico_close_lan.png" alt="close" style="width: 20px; height: 20px" />
        </span>
  
  <div class="box"></div>
      <qrcode-stream @decode="onDecode" @init="onInit" />
    </div>
  </template>
  
  <script>
  import { QrcodeStream } from 'vue-qrcode-reader'
  
  export default {
  
    components: { QrcodeStream },
  
    data () {
      return {
        result: '',
        error: ''
      }
    },
  
    methods: {
      onDecode (result) {
        this.result = result
        this.$emit('scanned', this.result)
      },
  
      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permission"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          } else if (error.name === 'InsecureContextError') {
            this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
          } else {
            this.error = `ERROR: Camera error (${error.name})`;
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .error {
    position: absolute;
       z-index: 56;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
    font-weight: bold;
    color: red;
  }

  .qr-scanner-component{
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 51;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden;
    background: white;
  }

  .qr-scanner-close {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 55;
    }
    .box{
        display: flex;
        width: 240px;
       aspect-ratio: 1;
       max-width: 90%;
       position: absolute;
       z-index: 56;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
       border: 2px solid #1296db;
       border-radius: 8px;
    }
  </style>